import type { JSX, MouseEventHandler } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'

import {
  TextAligning,
  TextBox,
  TextBoxColors,
  TextBoxTypes,
} from 'atoms/TextBox'
import { SeasonChipSC } from './SeasonBlock.styled'

export interface ISeasonChipProps {
  title?: ITextBoxProps['title']
  id?: number
  /** Id of the season the page currently shows; the matching chip is filled. */
  activeId?: number
  dataTestId?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

export const SeasonChip = ({
  title = '',
  id,
  activeId,
  dataTestId,
  onClick,
}: ISeasonChipProps): JSX.Element => {
  const selected = id != null && id === activeId

  return (
    <SeasonChipSC
      selected={selected}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <TextBox
        title={title}
        font={TextBoxTypes.FontSmBold}
        alignment={TextAligning.Center}
        color={
          selected
            ? TextBoxColors.TEXT_ICON_PRIMARY
            : TextBoxColors.TEXT_ICON_SECONDARY
        }
        maxLines={1}
      />
    </SeasonChipSC>
  )
}

SeasonChip.displayName = 'SeasonChip'
